import React, { useState, useEffect } from 'react';
import { 
  Users, 
  FileText, 
  Camera, 
  Briefcase, 
  UserCheck, 
  BarChart3, 
  Settings, 
  LogOut,
  Menu,
  X,
  Shield,
  UserCog,
  Crown,
  CalendarPlus2,
  UsersRound,
  PersonStanding,
  VideoIcon,
  LocationEdit,
  ContactIcon,
  Award,
  Trophy
} from 'lucide-react';
import PostedJobs from './PostedJobs.jsx';
import Register from './Register.jsx';
import Messages from './Messages.jsx';
import Addkse from './Addkse.jsx';
import MembersList from './Memberslist.jsx';
import Programslist from './Programslist.jsx';
import Applications from './Applications.jsx';
import Blog from './Blog.jsx';
import { useNavigate } from 'react-router-dom';
import PostedBlogs from './PostedBlogs.jsx';
import Investors from './Investors.jsx';
import JobApplicants from './JobApplicants.jsx';
import Postedimages from './Postedimages.jsx';
import Video from './Video.jsx';
import Postedvideos from './Postedvideos.jsx';
import Postedlocs from './Postedlocs.jsx';
import PostedWinners from './PostedWinners.jsx';
import Contactdetails from './Contactdetails.jsx';
//import Awards from './Awards.jsx';

const UnifiedDashboard = () => {


  const [currentUser, setCurrentUser] = useState(null);
  const [activeSection, setActiveSection] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  // Fetch user details from backend
  const fetchUserDetails = async () => {
    try {
      const email = sessionStorage.getItem('userEmail');
      if (!email) {
        // Redirect to login if no email found
        window.location.href = '/';
        return;
      }
      const response = await fetch(`/api/user?email=${email}`);
      const data = await response.json();
      if (response.ok) {
        setCurrentUser(data);
        console.log('currentuser', currentUser);
        setLoading(false);
      } else {
        // If user not found or error, redirect to login
        sessionStorage.removeItem('userEmail');
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      sessionStorage.removeItem('userEmail');
      window.location.href = '/';
    }
  };

// Add CSS animation for spinner
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

  // Handle logout
  const handleLogout = () => {
    sessionStorage.removeItem('userEmail');
    sessionStorage.clear(); // Clear all session data
    window.location.href = '/';
  };

  // Fetch user details on component mount
  useEffect(() => {
    fetchUserDetails();
  }, []);


  // Role permissions configuration
  const rolePermissions = {
    admin: ['manage_image', 'kseprograms', 'kseapplications', 'manage_video', 'winners'],
    //hr: ['manage_jobs', 'jobapplicants','contacts', 'messages', 'investors',  'manage_blogs', 'manage_locations'],
    hr: ['manage_jobs', 'jobapplicants', 'messages', 'investors',  'manage_blogs', 'manage_locations'],
    super_admin: ['all'] // Super admin has access to everything
  };

  // All available sidebar items
  const sidebarItems = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3, permission: 'dashboard' },
    { id: 'manage_image', label: 'Image Gallery', icon: Camera, permission: 'manage_image' },
    { id: 'manage_video', label: 'Video Gallery', icon: VideoIcon, permission: 'manage_video' },
    { id: 'manage_locations', label: 'Units & Locations', icon: LocationEdit, permission: 'manage_locations' },
    // { id: 'manage_contacts', label: 'Contacts', icon: ContactIcon, permission: 'manage_contacts' },
    { id: 'manage_blogs', label: 'Blog Management', icon: FileText, permission: 'manage_blogs' },
    //{ id: 'manage_awards', label: 'Awards', icon: Award, permission: 'manage_awards' },
    { id: 'manage_jobs', label: 'Job Management', icon: Briefcase, permission: 'manage_jobs' },
    { id: 'jobapplicants', label: 'Job Applications', icon: PersonStanding, permission: 'jobapplicants' },
    { id: 'messages', label: 'Messages', icon: UserCheck, permission: 'messages' },
    { id: 'settings', label: 'Settings', icon: Settings, permission: 'settings' },
    { id: 'kseprograms', label: 'KSE Programs', icon: CalendarPlus2 , permission: 'kseprograms'},
    { id: 'memberslist', label: 'Members List', icon: UsersRound, permission: 'memberslist'},
    { id: 'kseapplications', label: 'KSE Applications', icon: UserCog, permission: 'kseapplications'},
    { id: 'investors', label: 'Investors Management', icon: Users, permission: 'investors'},
    { id: 'winners', label: 'KSE Winners List', icon: Trophy, permission: 'winners'},
    
  ];

  // Check if user has permission for a specific item
  const hasPermission = (permission) => {
    if (!currentUser || !currentUser.role) return false;
    console.log('currentuser', currentUser);
    const userPermissions = rolePermissions[currentUser.role];
    //return userPermissions.includes('all') || userPermissions.includes(permission) || permission === 'dashboard' || permission === 'settings';
     return userPermissions && (userPermissions.includes('all') || userPermissions.includes(permission) || permission === 'dashboard' || permission === 'settings');
  };

  // Get filtered sidebar items based on user role
  const filteredSidebarItems = sidebarItems.filter(item => hasPermission(item.permission));

  // Role switching for demo purposes
//   const switchRole = (newRole) => {
//     setCurrentUser({ ...currentUser, role: newRole });
//     setActiveSection('dashboard');
//   };

 // Show loading state
  if (loading || !currentUser) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}>
          <div style={styles.spinner}></div>
          <p style={styles.loadingText}>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  // Get role display configuration
  const getRoleDisplay = (role) => {
    const roleConfig = {
      admin: { icon: Shield, colorClass: 'blue' },
      hr: { icon: UserCog, colorClass: 'green' },
      super_admin: { icon: Crown, colorClass: 'purple' }
    };
    return roleConfig[role] || roleConfig.admin;
  };

  // Render different content based on active section
  const renderContent = () => {
    const contentMap = {
      dashboard: (
        <div style={styles.contentSection}>
          <h1 style={styles.pageTitle}>Dashboard Overview</h1>
          <div style={styles.statsGrid}>
            {hasPermission('view_analytics') && (
              <div style={styles.statCard}>
                <h3 style={styles.statTitle}>Analytics</h3>
                <p style={styles.statNumber}>12,345</p>
                <p style={styles.statLabel}>Total Views</p>
              </div>
            )}
            {hasPermission('manage_jobs') && (
              <div style={styles.statCard}>
                <h3 style={styles.statTitle}>Active Jobs</h3>
                <p style={{...styles.statNumber, color: '#059669'}}>2</p>
                <p style={styles.statLabel}>Open Positions</p>
              </div>
            )}
            {hasPermission('manage_media') && (
              <div style={styles.statCard}>
                <h3 style={styles.statTitle}>Media Files</h3>
                <p style={{...styles.statNumber, color: '#7c3aed'}}>456</p>
                <p style={styles.statLabel}>Total Assets</p>
              </div>
            )}
          </div>
        </div>
      ),
      manage_image: (
        <div>
         
          <Postedimages />
        </div>
      ),
       manage_video: (
        <div>
         <Postedvideos />
          
        </div>
      ),
       manage_locations: (
        <div>
         <Postedlocs />
          
        </div>
      ),
      manage_blogs: (
        <div>
         <PostedBlogs />
          
        </div>
      ),
      // manage_awards: (
      //  <div>
      //   <Awards />
      //   </div>
      // ),
      view_analytics: (
        <div>
          <h1 style={styles.pageTitle}>Analytics</h1>
          <div style={styles.analyticsGrid}>
            <div style={styles.contentCard}>
              <h3 style={styles.cardTitle}>Traffic Overview</h3>
              <div style={styles.chartPlaceholder}>
                <p style={styles.placeholderText}>Chart visualization would go here</p>
              </div>
            </div>
            <div style={styles.contentCard}>
              <h3 style={styles.cardTitle}>User Engagement</h3>
              <div style={styles.metricsList}>
                <div style={styles.metric}>
                  <span>Page Views</span>
                  <span style={styles.metricValue}>15,234</span>
                </div>
                <div style={styles.metric}>
                  <span>Unique Visitors</span>
                  <span style={styles.metricValue}>8,456</span>
                </div>
                <div style={styles.metric}>
                  <span>Bounce Rate</span>
                  <span style={styles.metricValue}>23%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      manage_jobs: (
        <div>
          {/* <h1 style={styles.pageTitle}>Job Management</h1> */}
          <PostedJobs />
          {/* <div style={styles.contentCard}>
            <div style={styles.cardHeader}>
              <h3 style={styles.cardTitle}>Job Listings</h3>
              <button style={{...styles.primaryButton, backgroundColor: '#059669'}}>
                Post New Job
              </button>
            </div>
            {[1,2,3].map(i => (
              <div key={i} style={styles.jobCard}>
                <div style={styles.jobInfo}>
                  <h4 style={styles.jobTitle}>Software Engineer {i}</h4>
                  <p style={styles.jobDetails}>Full-time • Remote</p>
                  <p style={styles.jobMeta}>Posted 3 days ago</p>
                </div>
                <span style={styles.statusBadge}>
                  Active
                </span>
              </div>
            ))}
          </div> */}
        </div>
      ),
      jobapplicants: (
        <div>
          {/* <h1 style={styles.pageTitle}>Job Applications</h1> */}
          {/* <div style={styles.contentCard}>
            {[1,2,3,4].map(i => (
              <div key={i} style={styles.applicationCard}>
                <div style={styles.applicationInfo}>
                  <h4 style={styles.applicationName}>John Smith</h4>
                  <p style={styles.applicationPosition}>Applied for: Frontend Developer</p>
                  <p style={styles.applicationDate}>Submitted 2 days ago</p>
                </div>
                <div style={styles.applicationActions}>
                  <button style={styles.reviewButton}>
                    Review
                  </button>
                  <button style={styles.interviewButton}>
                    Interview
                  </button>
                </div>
              </div>
            ))}
          </div> */}
          <JobApplicants />
        </div>
      ),
      messages: (
        <div>
          {/* <h1 style={styles.pageTitle}>Messages from Users</h1> */}
          {/* <div style={styles.contentCard}>
            <div style={styles.candidatesGrid}>
              {[1,2,3,4,5,6].map(i => (
                <div key={i} style={styles.candidateCard}>
                  <div style={styles.candidateHeader}>
                    <div style={styles.candidateAvatar}>
                      <Users size={20} color="#6b7280" />
                    </div>
                    <div>
                      <h4 style={styles.candidateName}>Candidate {i}</h4>
                      <p style={styles.candidateRole}>React Developer</p>
                    </div>
                  </div>
                  <div style={styles.candidateDetails}>
                    <p>Experience: 3 years</p>
                    <p>Status: In Review</p>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
          <Messages />
        </div>
      ),
      settings: (
        <div>
           {/* <h1 style={styles.pageTitle}>Settings</h1> */}
          <div style={styles.contentCard}>
            <div>
              <h3 style={styles.settingsTitle}>Account Settings</h3>
              <div style={styles.settingsForm}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    Full Name
                  </label>
                  <input 
                    type="text" 
                    style={styles.input}
                    defaultValue={currentUser.name || currentUser.fullName || ''}
                    readOnly
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    Email
                  </label>
                  <input 
                    type="email" 
                    style={styles.input}
                    defaultValue={currentUser.email}
                    readOnly
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    Role
                  </label>
                  <input 
                    type="text" 
                    style={styles.input}
                    defaultValue={currentUser.role ? currentUser.role.replace('_', ' ').toUpperCase() : ''}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      winners: (
        <div>
          <PostedWinners />
          </div>
      ),
      manage_contacts: (
        <div>
          <Contactdetails />
          </div>
      ),
      // add_member: (
      //    <div>
      //      <h1 style={styles.pageTitle}>Add Member</h1>
      //          <Register />
      //     </div>
      // ),
      kseprograms: (
        <div>
          <Programslist />
          </div>
      ),
      memberslist: (
        <div>
         <MembersList />
        </div>
      ),
      kseapplications: (
        <div>
          <Applications />
        </div>
      ),
      investors: (
        <div>
         <Investors />
          </div>
      ),
      
    };

    return contentMap[activeSection] || contentMap.dashboard;
  };

  const roleDisplay = getRoleDisplay(currentUser.role);
  const RoleIcon = roleDisplay.icon;

  return (
    <div style={styles.container}>
      {/* Sidebar */}
      <div style={{...styles.sidebar, width: sidebarOpen ? '256px' : '80px'}}>
        {/* Header */}
        <div style={styles.sidebarHeader}>
          <div style={{...styles.headerContent, justifyContent: sidebarOpen ? 'space-between' : 'center'}}>
            <div style={{...styles.logoSection, justifyContent: sidebarOpen ? 'flex-start' : 'center'}}>
              <div style={{...styles.roleIcon, ...styles[`${roleDisplay.colorClass}Bg`]}}>
                <RoleIcon size={24} color={styles[`${roleDisplay.colorClass}Color`].color} />
              </div>
              {sidebarOpen && (
                <div>
                  <h2 style={styles.logoTitle}>Dashboard</h2>
                  <p style={styles.logoSubtitle}>{currentUser.role ? currentUser.role.replace('_', ' ') : ''}</p>
                </div>
              )}
            </div>
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              style={styles.toggleButton}
            >
              {sidebarOpen ? <X size={16} /> : <Menu size={16} />}
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav style={styles.navigation}>
          {filteredSidebarItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeSection === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => setActiveSection(item.id)}
                style={{
                  ...styles.navButton,
                  ...(isActive ? styles.navButtonActive : styles.navButtonInactive),
                  justifyContent: sidebarOpen ? 'flex-start' : 'center'
                }}
                title={!sidebarOpen ? item.label : ''}
              >
                <Icon size={20} />
                {sidebarOpen && <span style={styles.navButtonText}>{item.label}</span>}
              </button>
            );
          })}
        </nav>

        {/* User Profile & Role Switcher */}
        {/* <div style={styles.sidebarFooter}>
          {sidebarOpen && (
            <div style={styles.roleSwitcher}>
              <p style={styles.roleSwitcherLabel}>Switch Role (Demo):</p>
              <div style={styles.roleSwitcherButtons}>
                {['admin', 'hr', 'super_admin'].map((role) => (
                  <button
                    key={role}
                    onClick={() => switchRole(role)}
                    style={{
                      ...styles.roleButton,
                      ...(currentUser.role === role ? styles.roleButtonActive : styles.roleButtonInactive)
                    }}
                  >
                    {role.replace('_', ' ')}
                  </button>
                ))}
              </div>
            </div>
          )}
          
          <button style={{...styles.navButton, ...styles.navButtonInactive, justifyContent: sidebarOpen ? 'flex-start' : 'center'}}>
            <LogOut size={20} />
            {sidebarOpen && <span style={styles.navButtonText}>Logout</span>}
          </button>
        </div>
      </div> */}

      <div style={styles.sidebarFooter}>
          {sidebarOpen && (
            <div style={styles.userProfile}>
              <div style={styles.userProfileHeader}>
                <div style={{...styles.userAvatar, ...styles[`${roleDisplay.colorClass}Bg`]}}>
                  <span style={{...styles.userInitials, ...styles[`${roleDisplay.colorClass}Color`]}}>
                    {currentUser.name ? currentUser.name.split(' ').map(n => n[0]).join('').toUpperCase() : 
                     currentUser.fullName ? currentUser.fullName.split(' ').map(n => n[0]).join('').toUpperCase() : 'U'}
                  </span>
                </div>
                <div style={styles.userProfileInfo}>
                  <p style={styles.userProfileName}>{currentUser.name || currentUser.fullName || 'User'}</p>
                  <p style={styles.userProfileEmail}>{currentUser.email}</p>
                  <p style={styles.userProfileRole}>{currentUser.role ? currentUser.role.replace('_', ' ').toUpperCase() : ''}</p>
                </div>
              </div>
            </div>
          )}
          
          <button 
            style={{...styles.navButton, ...styles.navButtonInactive, justifyContent: sidebarOpen ? 'flex-start' : 'center'}}
            onClick={handleLogout}
          >
            <LogOut size={20} />
            {sidebarOpen && <span style={styles.navButtonText}>Logout</span>}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={styles.mainContent}>
        {/* Header */}
        <header style={styles.header}>
          <div style={styles.headerInner}>
            <div>
              <h1 style={styles.headerTitle}>
                {filteredSidebarItems.find(item => item.id === activeSection)?.label || 'Dashboard'}
              </h1>
            </div>
            <div style={styles.headerRight}>
              <div style={{...styles.roleBadge, ...styles[`${roleDisplay.colorClass}Bg`]}}>
                <RoleIcon size={16} color={styles[`${roleDisplay.colorClass}Color`].color} />
                <span style={{...styles.roleBadgeText, ...styles[`${roleDisplay.colorClass}Color`]}}>
                 {currentUser.role ? currentUser.role.replace('_', ' ').toUpperCase() : 'USER'}
                </span>
              </div>
              <div style={styles.userInfo}>
                <p style={styles.userName}>{currentUser.name || currentUser.fullName || 'User'}</p>
                <p style={styles.userEmail}>{currentUser.email}</p>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content Area */}
        <main style={styles.main}>
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

// CSS Styles Object
const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    overflow : 'hidden',
    backgroundColor: '#f3f4f6',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  },
  sidebar: {
    backgroundColor: 'white',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    transition: 'width 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  sidebarHeader: {
    padding: '16px',
    borderBottom: '1px solid #e5e7eb'
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center'
  },
  logoSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  roleIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  blueBg: {
    backgroundColor: '#dbeafe'
  },
  greenBg: {
    backgroundColor: '#dcfce7'
  },
  purpleBg: {
    backgroundColor: '#e9d5ff'
  },
  blueColor: {
    color: '#3b82f6'
  },
  greenColor: {
    color: '#059669'
  },
  purpleColor: {
    color: '#7c3aed'
  },
  logoTitle: {
    fontWeight: '600',
    color: '#111827',
    fontSize: '16px',
    margin: 0
  },
  logoSubtitle: {
    fontSize: '14px',
    color: '#6b7280',
    textTransform: 'capitalize',
    margin: 0
  },
  toggleButton: {
    padding: '8px',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    color: '#6b7280'
  },
  navigation: {
    flex: 1,
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  navButton: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 12px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease'
  },
  navButtonActive: {
    backgroundColor: '#dbeafe',
    color: '#1d4ed8'
  },
  navButtonInactive: {
    backgroundColor: 'transparent',
    color: '#374151'
  },
  navButtonText: {
    fontWeight: '500'
  },
  sidebarFooter: {
    padding: '16px',
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
   loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f3f4f6'
  },
  loadingSpinner: {
    textAlign: 'center'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #e5e7eb',
    borderTop: '4px solid #3b82f6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 16px'
  },
  loadingText: {
    color: '#6b7280',
    fontSize: '16px',
    margin: 0
  },
  userProfile: {
    marginBottom: '12px'
  },
  userProfileHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  userAvatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  userInitials: {
    fontSize: '14px',
    fontWeight: '600'
  },
  userProfileInfo: {
    flex: 1
  },
  userProfileName: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#111827',
    margin: '0 0 2px 0'
  },
  userProfileEmail: {
    fontSize: '12px',
    color: '#6b7280',
    margin: '0 0 2px 0'
  },
  userProfileRole: {
    fontSize: '11px',
    color: '#9ca3af',
    textTransform: 'uppercase',
    fontWeight: '500',
    margin: 0
  },
  roleSwitcher: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  roleSwitcherLabel: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#111827',
    margin: 0
  },
  roleSwitcherButtons: {
    display: 'flex',
    gap: '4px'
  },
  roleButton: {
    padding: '4px 8px',
    fontSize: '12px',
    borderRadius: '9999px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  roleButtonActive: {
    backgroundColor: '#dbeafe',
    color: '#1d4ed8'
  },
  roleButtonInactive: {
    backgroundColor: '#f3f4f6',
    color: '#6b7280'
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height:'100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    minWidth: '0'
  },
  header: {
    backgroundColor: 'white',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    borderBottom: '1px solid #e5e7eb',
    padding: '16px 24px'
  },
  headerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  headerTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#111827',
    margin: 0
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  roleBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '4px 12px',
    borderRadius: '9999px'
  },
  roleBadgeText: {
    fontSize: '14px',
    fontWeight: '500'
  },
  userInfo: {
    textAlign: 'right'
  },
  userName: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#111827',
    margin: 0
  },
  userEmail: {
    fontSize: '12px',
    color: '#6b7280',
    margin: 0
  },
  main: {
    flex: 1,
    overflow: 'auto',
    padding: '24px'
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  pageTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#111827',
    margin: 0
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px'
  },
  statCard: {
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '8px',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    border: '1px solid #e5e7eb'
  },
  statTitle: {
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 0 8px 0'
  },
  statNumber: {
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#2563eb',
    margin: '0'
  },
  statLabel: {
    fontSize: '14px',
    color: '#6b7280',
    margin: '0'
  },
  contentCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    border: '1px solid #e5e7eb',
    padding: '24px',
    marginBottom: '24px'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    margin: 0
  },
  primaryButton: {
    padding: '8px 16px',
    backgroundColor: '#2563eb',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500'
  },
  mediaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
    marginTop: '16px'
  },
  mediaPlaceholder: {
    aspectRatio: '1',
    backgroundColor: '#e5e7eb',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  blogPost: {
    borderLeft: '4px solid #3b82f6',
    paddingLeft: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    marginBottom: '12px'
  },
  blogTitle: {
    fontWeight: '500',
    margin: '0 0 4px 0'
  },
  blogMeta: {
    fontSize: '14px',
    color: '#6b7280',
    margin: 0
  },
  analyticsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gap: '24px'
  },
  chartPlaceholder: {
    height: '160px',
    background: 'linear-gradient(to right, #eff6ff, #dbeafe)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '16px'
  },
  placeholderText: {
    color: '#6b7280',
    margin: 0
  },
  metricsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '16px'
  },
  metric: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  metricValue: {
    fontWeight: '600'
  },
  jobCard: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  jobInfo: {
    flex: 1
  },
  jobTitle: {
    fontWeight: '500',
    margin: '0 0 4px 0'
  },
  jobDetails: {
    fontSize: '14px',
    color: '#6b7280',
    margin: '0 0 4px 0'
  },
  jobMeta: {
    fontSize: '14px',
    color: '#9ca3af',
    margin: 0
  },
  statusBadge: {
    padding: '4px 8px',
    backgroundColor: '#dcfce7',
    color: '#065f46',
    fontSize: '12px',
    borderRadius: '9999px'
  },
  applicationCard: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  applicationInfo: {
    flex: 1
  },
  applicationName: {
    fontWeight: '500',
    margin: '0 0 4px 0'
  },
  applicationPosition: {
    fontSize: '14px',
    color: '#6b7280',
    margin: '0 0 4px 0'
  },
  applicationDate: {
    fontSize: '14px',
    color: '#9ca3af',
    margin: 0
  },
  applicationActions: {
    display: 'flex',
    gap: '8px'
  },
  reviewButton: {
    padding: '4px 12px',
    backgroundColor: '#dcfce7',
    color: '#065f46',
    fontSize: '14px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  interviewButton: {
    padding: '4px 12px',
    backgroundColor: '#dbeafe',
    color: '#1e40af',
    fontSize: '14px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  },
  candidatesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '16px'
  },
  candidateCard: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '16px',
    transition: 'box-shadow 0.2s ease',
    cursor: 'pointer'
  },
  candidateHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '12px'
  },
  candidateAvatar: {
    width: '40px',
    height: '40px',
    backgroundColor: '#d1d5db',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  candidateName: {
    fontWeight: '500',
    margin: 0
  },
  candidateRole: {
    fontSize: '14px',
    color: '#6b7280',
    margin: 0
  },
  candidateDetails: {
    fontSize: '14px',
    color: '#6b7280',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  settingsTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px'
  },
  settingsForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151',
    marginBottom: '8px'
  },
  input: {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
  }
};

export default UnifiedDashboard;

// import React, { useState } from 'react';
// import { 
//   Users, 
//   FileText, 
//   Camera, 
//   Briefcase, 
//   UserCheck, 
//   BarChart3, 
//   Settings, 
//   LogOut,
//   Menu,
//   X,
//   Shield,
//   UserCog,
//   Crown
// } from 'lucide-react';

// const UnifiedDashboard = () => {
//   const [currentUser, setCurrentUser] = useState({
//     role: 'admin',
//     name: 'John Doe',
//     email: 'john@company.com'
//   });
//   const [activeSection, setActiveSection] = useState('dashboard');
//   const [sidebarOpen, setSidebarOpen] = useState(true);

//   // Role permissions configuration
//   const rolePermissions = {
//     admin: ['manage_media', 'manage_blogs', 'view_analytics'],
//     hr: ['manage_jobs', 'view_applications', 'manage_candidates'],
//     super_admin: ['all'] // Super admin has access to everything
//   };

//   // All available sidebar items
//   const sidebarItems = [
//     { id: 'dashboard', label: 'Dashboard', icon: BarChart3, permission: 'dashboard' },
//     { id: 'manage_media', label: 'Media Management', icon: Camera, permission: 'manage_media' },
//     { id: 'manage_blogs', label: 'Blog Management', icon: FileText, permission: 'manage_blogs' },
//     { id: 'view_analytics', label: 'Analytics', icon: BarChart3, permission: 'view_analytics' },
//     { id: 'manage_jobs', label: 'Job Management', icon: Briefcase, permission: 'manage_jobs' },
//     { id: 'view_applications', label: 'Applications', icon: Users, permission: 'view_applications' },
//     { id: 'manage_candidates', label: 'Candidates', icon: UserCheck, permission: 'manage_candidates' },
//     { id: 'settings', label: 'Settings', icon: Settings, permission: 'settings' }
//   ];

//   // Check if user has permission for a specific item
//   const hasPermission = (permission) => {
//     const userPermissions = rolePermissions[currentUser.role];
//     return userPermissions.includes('all') || userPermissions.includes(permission) || permission === 'dashboard' || permission === 'settings';
//   };

//   // Get filtered sidebar items based on user role
//   const filteredSidebarItems = sidebarItems.filter(item => hasPermission(item.permission));

//   // Role switching for demo purposes
//   const switchRole = (newRole) => {
//     setCurrentUser({ ...currentUser, role: newRole });
//     setActiveSection('dashboard');
//   };

//   // Get role icon and color
//   const getRoleDisplay = (role) => {
//     const roleConfig = {
//       admin: { icon: Shield, color: 'text-blue-500', bg: 'bg-blue-100' },
//       hr: { icon: UserCog, color: 'text-green-500', bg: 'bg-green-100' },
//       super_admin: { icon: Crown, color: 'text-purple-500', bg: 'bg-purple-100' }
//     };
//     return roleConfig[role] || roleConfig.admin;
//   };

//   // Render different content based on active section
//   const renderContent = () => {
//     const contentMap = {
//       dashboard: (
//         <div className="space-y-6">
//           <h1 className="text-2xl font-bold text-gray-900">Dashboard Overview</h1>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {hasPermission('view_analytics') && (
//               <div className="bg-white p-6 rounded-lg shadow-sm border">
//                 <h3 className="text-lg font-semibold mb-2">Analytics</h3>
//                 <p className="text-3xl font-bold text-blue-600">12,345</p>
//                 <p className="text-sm text-gray-600">Total Views</p>
//               </div>
//             )}
//             {hasPermission('manage_jobs') && (
//               <div className="bg-white p-6 rounded-lg shadow-sm border">
//                 <h3 className="text-lg font-semibold mb-2">Active Jobs</h3>
//                 <p className="text-3xl font-bold text-green-600">23</p>
//                 <p className="text-sm text-gray-600">Open Positions</p>
//               </div>
//             )}
//             {hasPermission('manage_media') && (
//               <div className="bg-white p-6 rounded-lg shadow-sm border">
//                 <h3 className="text-lg font-semibold mb-2">Media Files</h3>
//                 <p className="text-3xl font-bold text-purple-600">456</p>
//                 <p className="text-sm text-gray-600">Total Assets</p>
//               </div>
//             )}
//           </div>
//         </div>
//       ),
//       manage_media: (
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900 mb-6">Media Management</h1>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <p>Upload, organize, and manage your media assets here.</p>
//             <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
//               {[1,2,3,4].map(i => (
//                 <div key={i} className="aspect-square bg-gray-200 rounded-lg flex items-center justify-center">
//                   <Camera className="w-8 h-8 text-gray-400" />
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       ),
//       manage_blogs: (
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900 mb-6">Blog Management</h1>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <div className="space-y-4">
//               <div className="flex justify-between items-center">
//                 <h3 className="text-lg font-semibold">Recent Posts</h3>
//                 <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
//                   New Post
//                 </button>
//               </div>
//               {[1,2,3].map(i => (
//                 <div key={i} className="border-l-4 border-blue-500 pl-4 py-2">
//                   <h4 className="font-medium">Blog Post Title {i}</h4>
//                   <p className="text-sm text-gray-600">Published 2 days ago</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       ),
//       view_analytics: (
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900 mb-6">Analytics</h1>
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <h3 className="text-lg font-semibold mb-4">Traffic Overview</h3>
//               <div className="h-40 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg flex items-center justify-center">
//                 <p className="text-gray-600">Chart visualization would go here</p>
//               </div>
//             </div>
//             <div className="bg-white rounded-lg shadow-sm border p-6">
//               <h3 className="text-lg font-semibold mb-4">User Engagement</h3>
//               <div className="space-y-2">
//                 <div className="flex justify-between">
//                   <span>Page Views</span>
//                   <span className="font-semibold">15,234</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span>Unique Visitors</span>
//                   <span className="font-semibold">8,456</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span>Bounce Rate</span>
//                   <span className="font-semibold">23%</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       ),
//       manage_jobs: (
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900 mb-6">Job Management</h1>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <div className="space-y-4">
//               <div className="flex justify-between items-center">
//                 <h3 className="text-lg font-semibold">Job Listings</h3>
//                 <button className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
//                   Post New Job
//                 </button>
//               </div>
//               {[1,2,3].map(i => (
//                 <div key={i} className="border rounded-lg p-4 hover:bg-gray-50">
//                   <div className="flex justify-between items-start">
//                     <div>
//                       <h4 className="font-medium">Software Engineer {i}</h4>
//                       <p className="text-sm text-gray-600">Full-time • Remote</p>
//                       <p className="text-sm text-gray-500">Posted 3 days ago</p>
//                     </div>
//                     <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">
//                       Active
//                     </span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       ),
//       view_applications: (
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900 mb-6">Applications</h1>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <div className="space-y-4">
//               {[1,2,3,4].map(i => (
//                 <div key={i} className="border rounded-lg p-4">
//                   <div className="flex justify-between items-start">
//                     <div>
//                       <h4 className="font-medium">John Smith</h4>
//                       <p className="text-sm text-gray-600">Applied for: Frontend Developer</p>
//                       <p className="text-sm text-gray-500">Submitted 2 days ago</p>
//                     </div>
//                     <div className="flex gap-2">
//                       <button className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded">
//                         Review
//                       </button>
//                       <button className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded">
//                         Interview
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       ),
//       manage_candidates: (
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900 mb-6">Candidate Management</h1>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//               {[1,2,3,4,5,6].map(i => (
//                 <div key={i} className="border rounded-lg p-4 hover:shadow-md transition-shadow">
//                   <div className="flex items-center space-x-3 mb-3">
//                     <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center">
//                       <Users className="w-5 h-5 text-gray-600" />
//                     </div>
//                     <div>
//                       <h4 className="font-medium">Candidate {i}</h4>
//                       <p className="text-sm text-gray-600">React Developer</p>
//                     </div>
//                   </div>
//                   <div className="space-y-1 text-sm text-gray-600">
//                     <p>Experience: 3 years</p>
//                     <p>Status: In Review</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       ),
//       settings: (
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900 mb-6">Settings</h1>
//           <div className="bg-white rounded-lg shadow-sm border p-6">
//             <div className="space-y-6">
//               <div>
//                 <h3 className="text-lg font-semibold mb-4">Account Settings</h3>
//                 <div className="space-y-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Full Name
//                     </label>
//                     <input 
//                       type="text" 
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       defaultValue={currentUser.name}
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Email
//                     </label>
//                     <input 
//                       type="email" 
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       defaultValue={currentUser.email}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )
//     };

//     return contentMap[activeSection] || contentMap.dashboard;
//   };

//   const roleDisplay = getRoleDisplay(currentUser.role);
//   const RoleIcon = roleDisplay.icon;

//   return (
//     <div className="flex h-screen bg-gray-100">
//       {/* Sidebar */}
//       <div className={`${sidebarOpen ? 'w-64' : 'w-20'} bg-white shadow-lg transition-all duration-300 flex flex-col`}>
//         {/* Header */}
//         <div className="p-4 border-b">
//           <div className="flex items-center justify-between">
//             <div className={`flex items-center space-x-3 ${!sidebarOpen && 'justify-center'}`}>
//               <div className={`w-10 h-10 ${roleDisplay.bg} rounded-lg flex items-center justify-center`}>
//                 <RoleIcon className={`w-6 h-6 ${roleDisplay.color}`} />
//               </div>
//               {sidebarOpen && (
//                 <div>
//                   <h2 className="font-semibold text-gray-900">Dashboard</h2>
//                   <p className="text-sm text-gray-600 capitalize">{currentUser.role.replace('_', ' ')}</p>
//                 </div>
//               )}
//             </div>
//             <button
//               onClick={() => setSidebarOpen(!sidebarOpen)}
//               className="p-2 hover:bg-gray-100 rounded-lg"
//             >
//               {sidebarOpen ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
//             </button>
//           </div>
//         </div>

//         {/* Navigation */}
//         <nav className="flex-1 p-4 space-y-2">
//           {filteredSidebarItems.map((item) => {
//             const Icon = item.icon;
//             const isActive = activeSection === item.id;
            
//             return (
//               <button
//                 key={item.id}
//                 onClick={() => setActiveSection(item.id)}
//                 className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
//                   isActive 
//                     ? 'bg-blue-100 text-blue-700' 
//                     : 'text-gray-700 hover:bg-gray-100'
//                 } ${!sidebarOpen && 'justify-center'}`}
//                 title={!sidebarOpen ? item.label : ''}
//               >
//                 <Icon className="w-5 h-5" />
//                 {sidebarOpen && <span className="font-medium">{item.label}</span>}
//               </button>
//             );
//           })}
//         </nav>

//         {/* User Profile & Role Switcher */}
//         <div className="p-4 border-t space-y-3">
//           {sidebarOpen && (
//             <div className="space-y-2">
//               <p className="text-sm font-medium text-gray-900">Switch Role (Demo):</p>
//               <div className="flex space-x-1">
//                 {['admin', 'hr', 'super_admin'].map((role) => (
//                   <button
//                     key={role}
//                     onClick={() => switchRole(role)}
//                     className={`px-2 py-1 text-xs rounded-full transition-colors ${
//                       currentUser.role === role
//                         ? 'bg-blue-100 text-blue-700'
//                         : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                     }`}
//                   >
//                     {role.replace('_', ' ')}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
          
//           <button className={`w-full flex items-center space-x-3 px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors ${!sidebarOpen && 'justify-center'}`}>
//             <LogOut className="w-5 h-5" />
//             {sidebarOpen && <span>Logout</span>}
//           </button>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col overflow-hidden">
//         {/* Header */}
//         <header className="bg-white shadow-sm border-b px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div>
//               <h1 className="text-xl font-semibold text-gray-900">
//                 {filteredSidebarItems.find(item => item.id === activeSection)?.label || 'Dashboard'}
//               </h1>
//             </div>
//             <div className="flex items-center space-x-4">
//               <div className={`flex items-center space-x-2 px-3 py-1 ${roleDisplay.bg} rounded-full`}>
//                 <RoleIcon className={`w-4 h-4 ${roleDisplay.color}`} />
//                 <span className={`text-sm font-medium ${roleDisplay.color}`}>
//                   {currentUser.role.replace('_', ' ').toUpperCase()}
//                 </span>
//               </div>
//               <div className="text-right">
//                 <p className="text-sm font-medium text-gray-900">{currentUser.name}</p>
//                 <p className="text-xs text-gray-600">{currentUser.email}</p>
//               </div>
//             </div>
//           </div>
//         </header>

//         {/* Main Content Area */}
//         <main className="flex-1 overflow-auto p-6">
//           {renderContent()}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default UnifiedDashboard;

